const actions = {
  MODAL_OPEN: '[MODAL] Modal Open',
  MODAL_CLOSE: '[MODAL] Modal Close',
  MODAL_EDIT: '[MODAL] Modal Edit',
  REDIRECTED_FROM_ANOTHER_SERVICE: '[MODAL] Redirected from another service',
  modalOpen: (modal, modalProps) => ({
    type: actions.MODAL_OPEN,
    modal,
    modalProps,
  }),
  modalEdit: (modalProps) => ({
    type: actions.MODAL_EDIT,
    modalProps,
  }),
  modalClose: () => ({
    type: actions.MODAL_CLOSE,
  }),
  modalRedirected: (service: string) => ({
    type: actions.REDIRECTED_FROM_ANOTHER_SERVICE,
    payload: service,
  }),
};

export default actions;
